/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegistrationFinish
 */
export interface RegistrationFinish {
    /**
     * 
     * @type {string}
     * @memberof RegistrationFinish
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationFinish
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationFinish
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationFinish
     */
    organisationCode?: string;
}

/**
 * Check if a given object implements the RegistrationFinish interface.
 */
export function instanceOfRegistrationFinish(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RegistrationFinishFromJSON(json: any): RegistrationFinish {
    return RegistrationFinishFromJSONTyped(json, false);
}

export function RegistrationFinishFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegistrationFinish {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': !exists(json, 'password') ? undefined : json['password'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'organisationCode': !exists(json, 'organisationCode') ? undefined : json['organisationCode'],
    };
}

export function RegistrationFinishToJSON(value?: RegistrationFinish | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'organisationCode': value.organisationCode,
    };
}

